<script setup lang="ts">
defineProps<{
  title?: string;
}>();
</script>

<template>
  <div>
    <div
      class="text-primary text-uppercase fw-medium pb-4"
      style="font-size: 10px"
    >
      {{ title }}
    </div>
    <div class="d-flex flex-column gap-3">
      <slot></slot>
    </div>
  </div>
</template>

<style lang="scss" scoped></style>
